import { render, staticRenderFns } from "./GlList.vue?vue&type=template&id=662c7e08&"
import script from "./GlList.vue?vue&type=script&lang=js&"
export * from "./GlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports